// import isEqual from 'lodash/isEqual';
// import { useState, useCallback, useEffect, useContext } from 'react';
// import Card from '@mui/material/Card';
// import Table from '@mui/material/Table';
// import Button from '@mui/material/Button';
// import Container from '@mui/material/Container';
// import TableContainer from '@mui/material/TableContainer';
// import { paths } from 'src/routes/paths';
// import { useRouter } from 'src/routes/hooks';
// import { _userList, _roles, USER_STATUS_OPTIONS } from 'src/_mock';
// import { useBoolean } from 'src/hooks/use-boolean';
// import Scrollbar from 'src/components/scrollbar';
// import { ConfirmDialog } from 'src/components/custom-dialog';
// import { useSettingsContext } from 'src/components/settings';
// import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';
// import { errorMsg, modules, permissions } from 'src/api/constant';
// import { AuthContext } from 'src/auth/context/jwt';

// import {
//   useTable,
//   getComparator,
//   emptyRows,
//   TableNoData,
//   TableEmptyRows,
//   TableHeadCustom,
//   TablePaginationCustom,
//   TableSkeleton,
// } from 'src/components/table';
// import {
//   TableHead,
//   TableRow,
//   TableCell,
//   TableSortLabel,
//   Stack,
//   TextField,
//   Tooltip,
// } from '@mui/material';
// // types
// import { IUserTableFilters, IUserTableFilterValue } from 'src/types/user';
// import TableBody from '@mui/material/TableBody';
// import { useSnackbar } from 'notistack';
// import { professional } from 'src/types/product';
// import { useGetProfessional } from 'src/api/professionalapi';
// import axiosInstance, { endpoints } from 'src/utils/axios';
// import InputBase from '@mui/material/InputBase';
// import Divider from '@mui/material/Divider';
// import IconButton from '@mui/material/IconButton';
// import SearchIcon from '@mui/icons-material/Search';
// import Textfield from 'src/sections/_examples/mui/textfield-view/textfield';
// import { Box } from '@mui/system';
// import 'src/css/style.css';
// import Iconify from 'src/components/iconify/iconify';
// import ProfessionalTable from 'src/sections/product/view/professional-table-row';

// const TABLE_HEAD = [
//   // { id: 'sr', label: 'Sr.no' },
//   { id: 'name', label: 'Name' },
//   { id: 'email', label: 'Email' },
//   { id: 'date', label: 'Start Date' },
//   // { id: 'status', label: 'Status', width: 300 },
//   { id: 'action', label: 'Inactive/Active' },
// ];
// type SortDirection = 'asc' | 'desc';

// const defaultFilters: IUserTableFilters = {
//   name: '',
//   role: [],
//   status: 'all',
// };

// // ----------------------------------------------------------------------

// export default function AppUserProfessionalView() {
//   const table = useTable();
//   const { professionaldata, productsLoading, total } = useGetProfessional(table.page + 1);
//   const settings = useSettingsContext();
//   const { enqueueSnackbar } = useSnackbar();
//   const router = useRouter();
//   const confirm = useBoolean();
//   const [tableData, setTableData] = useState<professional[]>([]);
//   const [order, setOrder] = useState<SortDirection>('asc');
//   const [orderBy, setOrderBy] = useState<string | undefined>(undefined);
//   const [sorting, setSorting] = useState(false);

//   const [searchusername, setSearchusername] = useState('');
//   const [searchemail, setSearchemail] = useState('');
//   const [newshowdata, setNewshowdata] = useState(false);
//   const [neworderdata, setNeworderdata] = useState(false);
//   const [filterdata, setFilterdata] = useState('');
//   const { user } = useContext(AuthContext);

//   const users = user && user;

//   // useEffect(() => {
//   //   if (professionaldata.length) {
//   //     setTableData(professionaldata);
//   //   }
//   // }, [professionaldata]);

//   useEffect(() => {
//     if (professionaldata?.length) {
//       if (table.page === 0) {
//         setTableData(professionaldata);
//       } else {
//         setTableData((prevData) => [...prevData, ...professionaldata]);
//       }
//     }
//   }, [professionaldata, table.page]);

//   const [filters, setFilters] = useState(defaultFilters);

//   const dataFiltered = applyFilter({
//     inputData: tableData,
//     comparator: getComparator(table.order, table.orderBy),
//     filters,
//   });

//   const dataInPage = dataFiltered.slice(
//     table.page * table.rowsPerPage,
//     table.page * table.rowsPerPage + table.rowsPerPage
//   );

//   const denseHeight = table.dense ? 52 : 72;

//   const canReset = !isEqual(defaultFilters, filters);

//   const notFound = (!dataFiltered.length && canReset) || !dataFiltered.length;

//   const handleFilters = useCallback(
//     (name: string, value: IUserTableFilterValue) => {
//       table.onResetPage();
//       setFilters((prevState) => ({
//         ...prevState,
//         [name]: value,
//       }));
//     },
//     [table]
//   );

//   const handleDeleteRow = useCallback(
//     (id: string) => {
//       const deleteRow = tableData.filter((row) => row.user_id !== id);
//       setTableData(deleteRow);

//       table.onUpdatePageDeleteRow(dataInPage.length);
//     },
//     [dataInPage.length, table, tableData]
//   );

//   const handleEditRow = useCallback(
//     (id: string) => {
//       router.push(paths.dashboard.user.editprofessionalappuserdetails(id));
//     },
//     [router]
//   );

//   const handleFilterStatus = useCallback(
//     (event: React.SyntheticEvent, newValue: string) => {
//       handleFilters('status', newValue);
//     },
//     [handleFilters]
//   );

//   const handleViewRow = useCallback(
//     (id: string) => {
//       router.push(paths.dashboard.user.viewprofessionalappuserdetails(id));
//     },
//     [router]
//   );

//   const handleupdatestatus = async (id: any, user_type: number) => {
//     if (!users) {
//       enqueueSnackbar('Something went wrong', { variant: 'error' });
//       return;
//     }
//     if (!users[modules.account_type_pro].includes(permissions.UPDATE)) {
//       enqueueSnackbar(errorMsg, { variant: 'error' });
//       return;
//     }
//     try {
//       const res = await axiosInstance.put(
//         `${endpoints.professional.statueprofessional}?user_id=${id}&user_type=${user_type}`
//       );

//       const details = res.data.results;
//       const detail = details.map((item: any) => item.user_id);
//       const newstatus = details.map((item: any) => item.is_approved);

//       const newd = JSON.parse(detail);
//       const newdstatus = JSON.parse(newstatus);

//       if (newdstatus === true) {
//         enqueueSnackbar('Login status is active');
//       } else if (newdstatus === false) {
//         enqueueSnackbar('Login status is inactive');
//       }

//       setTableData((prevData: any) =>
//         prevData.map((pre: any) =>
//           pre.user_id === newd ? { ...pre, is_approved: newdstatus } : pre
//         )
//       );
//     } catch (error) {
//       if (error) {
//         enqueueSnackbar(error, { variant: 'error' });
//       } else {
//         enqueueSnackbar('Something went wrong. Please try again later', { variant: 'error' });
//       }
//     }
//   };

//   // const handlereset = async () => {
//   //   if (professionaldata.length) {
//   //     setTableData(professionaldata);

//   //     setSearchusername('');
//   //     setSearchemail('');
//   //   }
//   // };
//   const handleChangeusername = (event: any) => {
//     setSearchusername(event.target.value);
//   };

//   // if (professionaldata?.length) {

//   //   if (table.page === 0) {
//   //     setTableData(professionaldata);
//   //   } else {

//   //     setTableData((prevData) => [...prevData, ...professionaldata]);
//   //   }
//   // }

//   const handleuserclick = async (e: any) => {
//     e.preventDefault();

//     try {
//       const res = await axiosInstance.get(
//         `${endpoints.professional.getprofessional}?q=${searchusername}&column_name=username&order=asc&column_type=string`
//       );

//       const details = res.data.results;
//       if (details.length) {
//         setTableData(details);

//         table.onResetPage();

//         setFilterdata(res.data.total);
//       } else {
//         setTableData([]);
//       }
//     } catch (error) {
//       // Handle error
//     } finally {
//       setNewshowdata(true);
//     }
//   };

//   useEffect(() => {
//     if (newshowdata) {
//       table.onResetPage();

//       setNewshowdata(false);
//     }
//   }, [newshowdata, table]);

//   // useEffect(() => {
//   //   if (newshowdata && searchusername !== '') {
//   //     const filteredData = professionaldata.filter(
//   //       (row) =>
//   //         row.username.toLowerCase().includes(searchusername.toLowerCase()) ||
//   //         row.email.toLowerCase().includes(searchusername.toLowerCase())
//   //     );
//   //     setTableData(filteredData);
//   //   }
//   // }, [newshowdata, searchusername, professionaldata]);

//   useEffect(() => {
//     if (newshowdata && searchusername !== '') {
//       setTableData(tableData);
//     }
//   }, [newshowdata, searchusername, tableData]);

//   const handlecross = async () => {
//     setSearchusername('');
//     setTableData(professionaldata);
//   };

//   const handleSort = async (property: string) => {
//     const isAsc = orderBy === property && order === 'asc';
//     const newOrder: SortDirection = isAsc ? 'desc' : 'asc';
//     setOrder(newOrder);
//     setOrderBy(property);
//     setSorting(true);
//     try {
//       const res = await axiosInstance.get(
//         `${endpoints.professional.getprofessional}?q=&column_name=name&order=${newOrder}&column_type=string&page=${table.page+1}`
//       );
//       const details = res.data.results;
//       // Calculate the updated tableData
//       const startIndex = table.page * table.rowsPerPage;
//       const endIndex = Math.min(startIndex + table.rowsPerPage, startIndex + details.length);
//       const updatedTableData = [
//         ...tableData.slice(0, startIndex),
//         ...details.slice(0, endIndex - startIndex),
//         ...tableData.slice(endIndex),
//       ];
//       // Update the state using the calculated data
//       console.log("====================",updatedTableData)
//       setTableData(updatedTableData);
//     } catch (error) {
//       console.error('Error:', error);
//     } finally {
//       setSorting(false);
//       setNeworderdata(true);
//     }
//   };



//   return (
//     <>
//       <Container maxWidth={settings.themeStretch ? false : 'lg'}>
//         <CustomBreadcrumbs
//           heading="Professionals"
//           links={[{}]}
//           sx={{
//             // mb: { xs: 1, md: 1 },
//             mb: 0,
//           }}
//         />
//         <Stack sx={{ flexDirection: 'row', paddingBottom: '12px' }}>
//           <Box
//             sx={{
//               p: '2px 4px',
//               display: 'flex',
//               alignItems: 'center',
//               width: 300,
//               height: 45,
//               border: '1px solid gray',
//               borderRadius: '15px',
//               marginRight: '10px',
//             }}
//           >
//             <InputBase
//               sx={{ ml: 1, flex: 1 }}
//               placeholder="Search Username/Email"
//               value={searchusername}
//               onChange={handleChangeusername}
//               inputProps={{ 'aria-label': 'search google maps' }} //
//             />
//             {searchusername ? (
//               <>
//                 <IconButton
//                   type="button"
//                   onClick={handlecross}
//                   sx={{ p: '10px' }}
//                   aria-label="search"
//                 >
//                   <Iconify icon="basil:cross-solid" />
//                 </IconButton>
//               </>
//             ) : (
//               <></>
//             )}

//             <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
//             <IconButton
//               type="button"
//               onClick={handleuserclick}
//               sx={{ p: '10px' }}
//               aria-label="search"
//             >
//               <SearchIcon />
//             </IconButton>
//           </Box>

//           {/* <Box sx={{ marginTop: 'auto' }}>
//             <Button onClick={handlereset}>Clear</Button>
//           </Box> */}
//         </Stack>
//         <Card>
//           <TableContainer sx={{ position: 'relative', overflow: 'unset' }}>
//             <Scrollbar sx={{ maxHeight: 600 }}>
//               <Table stickyHeader size={table.dense ? 'medium' : 'small'} sx={{ minWidth: 960 }}>
//                 {/* <TableHeadCustom
//                   order={table.order}
//                   orderBy={table.orderBy}
//                   headLabel={TABLE_HEAD}
//                   rowCount={tableData.length}
//                   onSort={table.onSort}
//                   onSelectAllRows={(checked) =>
//                     table.onSelectAllRows(
//                       checked,
//                       tableData.map((row) => row.user_id)
//                     )
//                   }
//                 /> */}
//                 <TableHead>
//                   <TableRow>
//                     {TABLE_HEAD.map((headCell) => (
//                       <TableCell
//                         key={headCell.id}
//                         sortDirection={orderBy === headCell.id ? order : false}
//                         sx={{ backgroundColor: '#5da5da', color: 'white', backgroundImage: 'none' }}
//                       >
//                         <TableSortLabel
//                           active={orderBy === headCell.id}
//                           direction={orderBy === headCell.id ? order : undefined}
//                           onClick={() => handleSort(headCell.id)}
//                           sx={{
//                             '&:hover, &.MuiTableSortLabel-root.Mui-active,&.MuiTableSortLabel-focus':
//                               {
//                                 color: 'white',
//                                 '.MuiTableSortLabel-icon': {
//                                   color: 'white',
//                                 },
//                               },
//                           }}
//                         >
//                           {headCell.label}
//                         </TableSortLabel>
//                       </TableCell>
//                     ))}
//                   </TableRow>
//                 </TableHead>
//                 <TableBody>
//                   {productsLoading ? (
//                     [...Array(table.rowsPerPage)].map((i, index) => (
//                       <TableSkeleton key={index} sx={{ height: denseHeight }} />
//                     ))
//                   ) : (
//                     <>
//                       {tableData
//                         .slice(
//                           table.page * table.rowsPerPage,
//                           table.page * table.rowsPerPage + table.rowsPerPage
//                         )
//                         .map((row, index) => {
//                           const rowIndex = table.page * table.rowsPerPage + index + 1;
//                           // console.log("cxvhkxvhkx",row)
//                           return (
//                             <ProfessionalTable
//                               key={row.user_id}
//                               index={index}
//                               row={row}
//                               selected={table.selected.includes(row.user_id)}
//                               onSelectRow={() => table.onSelectRow(row.user_id)}
//                               onDeleteRow={() => handleDeleteRow(row.user_id)}
//                               onEditRow={() => handleEditRow(row.user_id)}
//                               onViewRow={() => handleViewRow(row.user_id)}
//                               onUpdateStatus={() => handleupdatestatus(row.user_id, row.user_type)}
//                             />
//                           );
//                         })}
//                     </>
//                   )}
//                   {/* <TableEmptyRows
//                     height={denseHeight}
//                     emptyRows={emptyRows(table.page, table.rowsPerPage, tableData.length)}
//                   /> */}
//                   <TableNoData notFound={notFound} />
//                 </TableBody>
//               </Table>
//             </Scrollbar>
//           </TableContainer>
//           {/* <TablePaginationCustom
//             // count={total}
//             count={searchusername ? Number(filterdata) : Number(total)}
//             page={table.page}
//             rowsPerPage={table.rowsPerPage}
//             onPageChange={table.onChangePage}
//             onRowsPerPageChange={table.onChangeRowsPerPage}
//             dense={table.dense}
//             onChangeDense={table.onChangeDense}
//           /> */}

//           <TablePaginationCustom
//             count={searchusername ? Number(filterdata) : Number(total)}
//             page={table.page}
//             rowsPerPage={table.rowsPerPage}
//             onPageChange={(event, newPage) => {
//               if (!sorting) {
//                 table.onChangePage(event, newPage);
//               }
//             }}
//             onRowsPerPageChange={table.onChangeRowsPerPage}
//             dense={table.dense}
//             onChangeDense={table.onChangeDense}
//           />
//         </Card>
//       </Container>

//       <ConfirmDialog
//         open={confirm.value}
//         onClose={confirm.onFalse}
//         title="Delete"
//         content={
//           <>
//             Are you sure want to delete <strong> {table.selected.length} </strong> items?
//           </>
//         }
//         action={
//           <Button
//             variant="contained"
//             color="error"
//             onClick={() => {
//               confirm.onFalse();
//             }}
//           >
//             Delete
//           </Button>
//         }
//       />
//     </>
//   );
// }

// // ----------------------------------------------------------------------

// function applyFilter({
//   inputData,
//   comparator,
//   filters,
// }: {
//   inputData: professional[];
//   comparator: (a: any, b: any) => number;
//   filters: any;
// }) {
//   const { name, status, role } = filters;

//   const stabilizedThis = inputData.map((el, index) => [el, index] as const);

//   // console.log("this is",stabilizedThis)

//   stabilizedThis.sort((a, b) => {
//     const order = comparator(a[0], b[0]);
//     if (order !== 0) return order;
//     return a[1] - b[1];
//   });

//   inputData = stabilizedThis.map((el) => el[0]);

//   return inputData;
// }





import isEqual from 'lodash/isEqual';
import { useState, useCallback, useEffect, useContext, useRef } from 'react';
import Card from '@mui/material/Card';
import Table from '@mui/material/Table';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import TableContainer from '@mui/material/TableContainer';
import { paths } from 'src/routes/paths';
import { useRouter } from 'src/routes/hooks';
import { useBoolean } from 'src/hooks/use-boolean';
import Scrollbar from 'src/components/scrollbar';
import { ConfirmDialog } from 'src/components/custom-dialog';
import { useSettingsContext } from 'src/components/settings';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';
import { errorMsg, modules, permissions } from 'src/api/constant';
import { AuthContext } from 'src/auth/context/jwt';
import {
  useTable,
  TableNoData,
  TablePaginationCustom,
  TableSkeleton,
} from 'src/components/table';
import {
  TableHead,
  TableRow,
  TableCell,
  TableSortLabel,
  Stack,
} from '@mui/material';
import TableBody from '@mui/material/TableBody';
import { useSnackbar } from 'notistack';
import { professional } from 'src/types/product';
import { useGetProfessional } from 'src/api/professionalapi';
import axiosInstance, { endpoints } from 'src/utils/axios';
import InputBase from '@mui/material/InputBase';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import { Box } from '@mui/system';
import 'src/css/style.css';
import Iconify from 'src/components/iconify/iconify';
import ProfessionalTable from 'src/sections/product/view/professional-table-row';

const TABLE_HEAD = [
  { id: 'name', label: 'Name' },
  { id: 'email', label: 'Email' },
  { id: 'created_at', label: 'Start Date' },
  { id: 'action', label: 'Inactive/Active' },
];

type SortDirection = 'asc' | 'desc';

export default function AppUserProfessionalView() {
  const table = useTable();
  const settings = useSettingsContext();
  const { enqueueSnackbar } = useSnackbar();
  const router = useRouter();
  const confirm = useBoolean();
  const { user } = useContext(AuthContext);

  // ─── Mode: 'normal' uses the hook; 'search'/'sort' use fetchPage() ───────────
  const [mode, setMode] = useState<'normal' | 'search' | 'sort'>('normal');
  const [tableData, setTableData] = useState<professional[]>([]);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [loading, setLoading] = useState(false);

  // Sort state
  const [order, setOrder] = useState<SortDirection>('asc');
  const [orderBy, setOrderBy] = useState<string>('');

  // Search state
  const [searchusername, setSearchusername] = useState('');
  const [submittedQuery, setSubmittedQuery] = useState('');   // last executed search
  const [submittedOrderBy, setSubmittedOrderBy] = useState(''); // last executed sort col

  // ─── Normal mode hook — pass null to disable when not in normal mode ──────────
  const { professionaldata, productsLoading, total } = useGetProfessional(
    mode === 'normal' ? table.page + 1 : undefined
  );

  useEffect(() => {
    if (mode !== 'normal') return;
    setTableData(professionaldata ?? []);
    setTotalCount(Number(total ?? 0));
  }, [professionaldata, total, mode]);

  // ─── Generic fetch for search / sort (server handles pagination) ─────────────
  const fetchPage = useCallback(
    async (page: number, query: string, col: string, dir: SortDirection) => {
      setLoading(true);
      try {
        const res = await axiosInstance.get(
          `${endpoints.professional.getprofessional}?q=${encodeURIComponent(query)}&column_name=${col || 'name'}&order=${dir}&column_type=string&page=${page + 1}`
        );
        setTableData(res.data.results ?? []);
        setTotalCount(Number(res.data.total ?? 0));
      } catch (error) {
        console.error('Fetch error:', error);
      } finally {
        setLoading(false);
      }
    },
    []
  );

  // ─── Re-fetch on page change while in search or sort mode ────────────────────
  useEffect(() => {
    if (mode === 'search') {
      fetchPage(table.page, submittedQuery, 'username', order);
    } else if (mode === 'sort') {
      fetchPage(table.page, '', submittedOrderBy, order);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [table.page]);

  // ─── Search ───────────────────────────────────────────────────────────────────
  const handleuserclick = async (e: React.SyntheticEvent) => {
    e.preventDefault();
    const query = searchusername.trim();
    if (!query) return;

    setSubmittedQuery(query);
    setMode('search');
    table.onResetPage();
    await fetchPage(0, query, 'username', order);
  };

  const handlecross = () => {
    setSearchusername('');
    setSubmittedQuery('');
    setMode('normal');
    setTableData([]);
    setTotalCount(0);
    table.onResetPage();
  };

  // ─── Sort ─────────────────────────────────────────────────────────────────────
  const handleSort = async (property: string) => {
    const isAsc = orderBy === property && order === 'asc';
    const newOrder: SortDirection = isAsc ? 'desc' : 'asc';
    setOrder(newOrder);
    setOrderBy(property);
    setSubmittedOrderBy(property);
    setMode('sort');
    table.onResetPage();
    await fetchPage(0, '', property, newOrder);
  };

  // ─── Row actions ──────────────────────────────────────────────────────────────
  const handleDeleteRow = useCallback((id: string) => {
    setTableData((prev) => prev.filter((row) => row.user_id !== id));
    setTotalCount((prev) => Math.max(0, prev - 1));
  }, []);

  const handleEditRow = useCallback(
    (id: string) => router.push(paths.dashboard.user.editprofessionalappuserdetails(id)),
    [router]
  );

  const handleViewRow = useCallback(
    (id: string) => router.push(paths.dashboard.user.viewprofessionalappuserdetails(id)),
    [router]
  );

  const handleupdatestatus = async (id: any, user_type: number) => {
    if (!user) { enqueueSnackbar('Something went wrong', { variant: 'error' }); return; }
    if (!user[modules.account_type_pro].includes(permissions.UPDATE)) {
      enqueueSnackbar(errorMsg, { variant: 'error' }); return;
    }
    try {
      const res = await axiosInstance.put(
        `${endpoints.professional.statueprofessional}?user_id=${id}&user_type=${user_type}`
      );
      const details = res.data.results;
      const newd = JSON.parse(details.map((item: any) => item.user_id));
      const newdstatus = JSON.parse(details.map((item: any) => item.is_approved));
     enqueueSnackbar(
  newdstatus
    ? 'Account activated. All related account types are now active.'
    : 'Account deactivated. All related account types are now inactive.'
);
      setTableData((prev) =>
        prev.map((row) => (row.user_id === newd ? { ...row, is_approved: newdstatus } : row))
      );
    } catch (error) {
      enqueueSnackbar(
        error ? String(error) : 'Something went wrong. Please try again later',
        { variant: 'error' }
      );
    }
  };

  // ─── Derived ──────────────────────────────────────────────────────────────────
  const isLoading = mode === 'normal' ? productsLoading : loading;
  const denseHeight = table.dense ? 52 : 72;
  const notFound = !isLoading && tableData.length === 0;

  // ─── Render ───────────────────────────────────────────────────────────────────
  return (
    <>
      <Container maxWidth={settings.themeStretch ? false : 'lg'}>
        <CustomBreadcrumbs heading="Professionals" links={[{}]} sx={{ mb: 0 }} />

        <Stack sx={{ flexDirection: 'row', paddingBottom: '12px' }}>
          <Box
            sx={{
              p: '2px 4px',
              display: 'flex',
              alignItems: 'center',
              width: 300,
              height: 45,
              border: '1px solid gray',
              borderRadius: '15px',
              marginRight: '10px',
            }}
          >
            <InputBase
              sx={{ ml: 1, flex: 1 }}
              placeholder="Search Username/Email"
              value={searchusername}
              onChange={(e) => setSearchusername(e.target.value)}
              onKeyDown={(e) => { if (e.key === 'Enter') handleuserclick(e); }}
              inputProps={{ 'aria-label': 'search' }}
            />
            {searchusername && (
              <IconButton type="button" onClick={handlecross} sx={{ p: '10px' }} aria-label="clear">
                <Iconify icon="basil:cross-solid" />
              </IconButton>
            )}
            <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
            <IconButton type="button" onClick={handleuserclick} sx={{ p: '10px' }} aria-label="search">
              <SearchIcon />
            </IconButton>
          </Box>
        </Stack>

        <Card>
          <TableContainer sx={{ position: 'relative', overflow: 'unset' }}>
            <Scrollbar sx={{ maxHeight: 600 }}>
              <Table stickyHeader size={table.dense ? 'medium' : 'small'} sx={{ minWidth: 960 }}>
                <TableHead>
                  <TableRow>
                    {TABLE_HEAD.map((headCell) => (
                      <TableCell
                        key={headCell.id}
                        sortDirection={orderBy === headCell.id ? order : false}
                        sx={{ backgroundColor: '#5da5da', color: 'white', backgroundImage: 'none' }}
                      >
                        <TableSortLabel
                          active={orderBy === headCell.id}
                          direction={orderBy === headCell.id ? order : undefined}
                          onClick={() => handleSort(headCell.id)}
                          sx={{
                            '&:hover, &.MuiTableSortLabel-root.Mui-active, &.MuiTableSortLabel-focus': {
                              color: 'white',
                              '.MuiTableSortLabel-icon': { color: 'white' },
                            },
                          }}
                        >
                          {headCell.label}
                        </TableSortLabel>
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>

                <TableBody>
                  {isLoading ? (
                    [...Array(table.rowsPerPage)].map((_, i) => (
                      <TableSkeleton key={i} sx={{ height: denseHeight }} />
                    ))
                  ) : (
                    tableData.map((row, index) => (
                      <ProfessionalTable
                        key={row.user_id}
                        index={index}
                        row={row}
                        selected={table.selected.includes(row.user_id)}
                        onSelectRow={() => table.onSelectRow(row.user_id)}
                        onDeleteRow={() => handleDeleteRow(row.user_id)}
                        onEditRow={() => handleEditRow(row.user_id)}
                        onViewRow={() => handleViewRow(row.user_id)}
                        onUpdateStatus={() => handleupdatestatus(row.user_id, row.user_type)}
                      />
                    ))
                  )}
                  <TableNoData notFound={notFound} />
                </TableBody>
              </Table>
            </Scrollbar>
          </TableContainer>

          <TablePaginationCustom
            count={mode === 'normal' ? Number(total ?? 0) : totalCount}
            page={table.page}
            rowsPerPage={table.rowsPerPage}
            onPageChange={table.onChangePage}
            onRowsPerPageChange={table.onChangeRowsPerPage}
            dense={table.dense}
            onChangeDense={table.onChangeDense}
          />
        </Card>
      </Container>

      <ConfirmDialog
        open={confirm.value}
        onClose={confirm.onFalse}
        title="Delete"
        content={<>Are you sure want to delete <strong>{table.selected.length}</strong> items?</>}
        action={
          <Button variant="contained" color="error" onClick={() => confirm.onFalse()}>
            Delete
          </Button>
        }
      />
    </>
  );
}